export class Controller {

    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.domain = {...this.domain};
    }

    save() {
        this.isSaving = true;
        this.DirectoriesResource
            .editDomain(this.companyId, this.directory.id, this.domain)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.directory-integration.manage.domains.edit-domain.updated'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/edit-domain/edit-domain.controller.js